'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _CouponCodes = require('./CouponCodes');

var _CouponCodes2 = _interopRequireDefault(_CouponCodes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CouponCodesWidget = function (_Component) {
    _inherits(CouponCodesWidget, _Component);

    function CouponCodesWidget() {
        _classCallCheck(this, CouponCodesWidget);

        return _possibleConstructorReturn(this, (CouponCodesWidget.__proto__ || Object.getPrototypeOf(CouponCodesWidget)).apply(this, arguments));
    }

    _createClass(CouponCodesWidget, [{
        key: 'render',
        value: function render() {
            var title = 'Rabattkoder';
            var discounts = this.props.discounts;


            return _react2.default.createElement(_CouponCodes2.default, {
                title: title,
                discounts: discounts,
                theme: this.props.theme
            });
        }
    }]);

    return CouponCodesWidget;
}(_react.Component);

CouponCodesWidget.propTypes = {
    theme: _propTypes2.default.shape({
        title: _propTypes2.default.string
    }).isRequired,
    discounts: _propTypes2.default.array // eslint-disable-line react/forbid-prop-types
};
CouponCodesWidget.defaultProps = {
    theme: {
        title: ''
    },
    discounts: []
};
exports.default = CouponCodesWidget;
//# sourceMappingURL=index.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@vg/coupon-codes/lib/cjs/CouponCodes/index.js
 ** module id = 717
 ** module chunks = 1
 **/